// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgBell24 = forwardRef(({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
	let ariaLabelledBy = titleid ? titleid : "";
	ariaLabelledBy += desc && descid ? ` ${descid}` : "";
	ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
	props["aria-labelledby"] = ariaLabelledBy;
	return (
		<Svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			title={title}
			titleid={titleid}
			desc={desc}
			descid={descid}
			aria-labelledby={ariaLabelledBy}
			aria-hidden={!ariaLabelledBy}
			ref={ref}
			{...props}
		>
			{!!title && <title id={titleId}>{title}</title>}
			{!!desc && <desc id={descId}>{desc}</desc>}
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 22C10.2898 22 8.88805 20.679 8.7596 19.0017L3.10562 19C2.77424 19 2.50562 18.7314 2.50562 18.4C2.50562 18.2839 2.53929 18.1703 2.60255 18.073L4.99962 14.384L5 10C5 6.13401 8.13401 3 12 3C15.866 3 19 6.13401 19 10L18.9996 14.116L21.4385 18.0859C21.482 18.1568 21.5102 18.2357 21.5216 18.3174L21.5273 18.4C21.5273 18.7314 21.2586 19 20.9273 19L15.2405 19.0007C15.1125 20.6785 13.7106 22 12 22ZM13.7321 19.0011L10.268 19.0021C10.3902 19.8491 11.1191 20.5 12 20.5C12.8812 20.5 13.6103 19.8486 13.7321 19.0011ZM6.5 10.0001C6.5 6.96243 8.96244 4.5 12 4.5C15.0376 4.5 17.5 6.96243 17.5 10L17.4996 14.5399L19.3176 17.5H4.76262L6.49958 14.8286L6.5 10.0001Z"
			/>
		</Svg>
	);
});
SvgBell24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgBell24;
